(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skin-programs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(tab) {
      var root = tab.closest('[data-sp-root]');
      if (!root) return;
      root.querySelectorAll('[data-sp-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-sp-panel]').forEach(function (p) {
        var on = p.id === tab.getAttribute('aria-controls');
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
      var select = root.querySelector('[data-sp-select]');
      if (select) select.value = tab.getAttribute('aria-controls');
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-sp-tab]');
      if (tab) activate(tab);
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-sp-select]')) return;
      var root = e.target.closest('[data-sp-root]');
      var tab = root && root.querySelector('[data-sp-tab][aria-controls="' + e.target.value + '"]');
      if (tab) activate(tab);
    });

    // Theme editor: selecting a block in the sidebar opens its tab
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target;
      if (!panel || !panel.id) return;
      var tab = document.querySelector('[data-sp-tab][aria-controls="' + panel.id + '"]');
      if (tab) activate(tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
